import * as additionalIcons from './additionalIcons';
import { vkIconsMap } from './vkIcons';

export const additionalIconsMap = {
  vkhrtek_code: {
    16: additionalIcons.CodeIcon,
  },
  vkhrtek_code_block: {
    16: additionalIcons.CodeBlockIcon,
  },
  vkhrtek_justify_format: {
    16: additionalIcons.JustifyFormatIcon,
  },
  vkhrtek_omega: {
    16: additionalIcons.OmegaIcon,
  },
  vkhrtek_reference: {
    16: additionalIcons.ReferenceIcon,
  },
  vkhrtek_subscript: {
    16: additionalIcons.SubscriptIcon,
  },
  vkhrtek_superscript: {
    16: additionalIcons.SuperscriptIcon,
  },
  vkhrtek_video_link: {
    20: additionalIcons.VideoLinkIcon,
  },
  vkhrtek_company_page: {
    20: additionalIcons.SidebarCompanyPageIcon,
  },
  vkhrtek_vacations_page: {
    20: additionalIcons.SidebarVacationsPageIcon,
  },
  vkhrtek_add_section: {
    24: additionalIcons.AddSectionIcon,
  },
  vkhrtek_add_link: {
    24: additionalIcons.AddLinkIcon,
  },
  vkhrtek_vacation: {
    14: additionalIcons.VacationIcon,
  },
  vkhrtek_visibility_off: {
    16: additionalIcons.VisibilityOffIcon,
  },
  vkhrtek_maternity_leave: {
    16: additionalIcons.MaternityLeaveIcon,
  },
  vkhrtek_medical: {
    16: additionalIcons.MedicalIcon,
  },
  vkhrtek_absence: {
    16: additionalIcons.AbsenceIcon,
  },
  vkhrtek_separate_unit: {
    16: additionalIcons.SeparateUnitIcon,
  },
  vkhrtek_schedule_syncron: {
    16: additionalIcons.ScheduleSyncronIcon,
  },
  vkhrtek_file: {
    56: additionalIcons.FileIcon,
  },
  vkhrtek_award: {
    48: additionalIcons.AwardIcon,
  },
  vkhrtek_gender: {
    48: additionalIcons.GenderIcon,
  },
  vkhrtek_man: {
    48: additionalIcons.ManIcon,
  },
  vkhrtek_woman: {
    48: additionalIcons.WomanIcon,
  },
  vkhrtek_task_list: {
    40: additionalIcons.TaskListIcon,
  },
  vkhrtek_system_message: {
    24: additionalIcons.SystemMessageIcon,
  },
  vkhrtek_download_file: {
    16: additionalIcons.DownloadFileIcon,
  },
  vkhrtek_gosuslugi: {
    24: additionalIcons.GosUslugiIcon,
  },
  vkhrtek_done_bordered: {
    64: additionalIcons.DoneBorderedIcon,
  },
  vkhrtek_vk_pointer: {
    56: additionalIcons.VkPointerIcon,
  },
  vkhrtek_xml_file: {
    95: additionalIcons.XmlFileIcon,
  },
  vkhrtek_sig_file: {
    95: additionalIcons.SigFileIcon,
  },
  vkhrtek_export_xlsx: {
    16: additionalIcons.ExportXlsxIcon,
  },
  vkhrtek_energy_important: {
    20: additionalIcons.EnergyImportantIcon,
  },
  vkhrtek_dots_vertical_disabled: {
    24: additionalIcons.DotsVerticalDisabledIcon,
  },
  vkhrtek_add_link_item: {
    20: additionalIcons.AddLinkIcon,
  },
  vkhrtek_add_section_item: {
    20: additionalIcons.AddSectionIcon,
  },
  vkhrtek_drag_disabled: {
    24: additionalIcons.DragDisabledIcon,
  },
  vkhrtek_at: {
    16: additionalIcons.AtIcon,
  },
  vkhrtek_stage_error: {
    16: additionalIcons.StageErrorIcon,
  },
  vkhrtek_stage_checked: {
    16: additionalIcons.StageCheckedIcon,
  },
  vkhrtek_slider_outline: {
    16: additionalIcons.SliderOutlineIcon,
  },
  vkhrtek_edit_circle_outline: {
    16: additionalIcons.EditCircleOutlineIcon,
  },
  vkhrtek_circle_outline: {
    16: additionalIcons.CircleOutlineIcon,
  },
  vkhrtek_employee_info: {
    20: additionalIcons.EmployeeInfo,
  },
  vkhrtek_app_gallery: {
    24: additionalIcons.AppGalleryIcon,
  },
  vkhrtek_app_store: {
    24: additionalIcons.AppStoreIcon,
  },
  vkhrtek_google_play: {
    24: additionalIcons.GooglePlayIcon,
  },
  vkhrtek_ru_store: {
    24: additionalIcons.RuStoreIcon,
  },
  vkhrtek_filter_filled: {
    24: additionalIcons.FilterFilledIcon,
  },
  vkhrtek_status_in_progress: {
    16: additionalIcons.StatusInProgressIcon,
  },
  vkhrtek_rectangles_2_outline: {
    24: additionalIcons.Rectangles2Outline,
  },
  vkhrtek_absence_3d: {
    48: additionalIcons.Absence3DIcon,
  },
  vkhrtek_benefits_3d: {
    48: additionalIcons.Benefits3DIcon,
  },
  vkhrtek_candidates_3d: {
    48: additionalIcons.Candidates3DIcon,
  },
  vkhrtek_competencies_3d: {
    48: additionalIcons.Competencies3DIcon,
  },
  vkhrtek_event_3d: {
    48: additionalIcons.Event3DIcon,
  },
  vkhrtek_payroll_3d: {
    48: additionalIcons.Payroll3DIcon,
  },
  vkhrtek_review_3d: {
    48: additionalIcons.Review3DIcon,
  },
  vkhrtek_structure_3d: {
    48: additionalIcons.Structure3DIcon,
  },
  vkhrtek_training_3d: {
    48: additionalIcons.Training3DIcon,
  },
  vkhrtek_businesstrip_3d: {
    48: additionalIcons.Businesstrip3DIcon,
  },
  vkhrtek_payslips_3d: {
    48: additionalIcons.Payslips3DIcon,
  },
  vkhrtek_personal_3d: {
    48: additionalIcons.Personal3DIcon,
  },
  vkhrtek_policy_3d: {
    48: additionalIcons.Policy3DIcon,
  },
  vkhrtek_statements_3d: {
    48: additionalIcons.Statements3DIcon,
  },
  vkhrtek_clock_circle: {
    16: additionalIcons.ClockCircleIcon,
  },
  vkhrtek_transparency_outline_2: {
    20: additionalIcons.TransparencyOutline2Icon,
  },
};

export default { ...vkIconsMap, ...additionalIconsMap };
